import React, { Component } from "react";

class Textarea extends Component {
  state = {
    formclass: "form-group custom-input",
  };

  handleFocus = () => {
    this.setState({ formclass: "form-group custom-input show on" });
  };

  handleBlur = (e) => {
    const classname = e.target.value ? "form-group custom-input show on" : "form-group custom-input";
    this.setState({ formclass: classname });
  };

  componentDidMount() {
    const classname = this.props.value ? "form-group custom-input show on" : "form-group custom-input";
    this.setState({ formclass: classname });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      const classname = this.props.value ? "form-group custom-input show on" : "form-group custom-input";
      this.setState({ formclass: classname });
    }
  }
  render() {
    const { name, label, error, maxLength, minLength, placeholder, ...rest } = this.props;
    return (
      <div>
        {label && <label htmlFor={name}>{label}</label>}
        <textarea
          name={name}
          id={name}
          placeholder={placeholder}
          maxLength={maxLength ? maxLength : false}
          minLength={minLength ? minLength : false}
          className={error ? "form-control error" : "form-control"}
          multiline
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          {...rest}
        />
      </div>
    );
  }
}

export default Textarea;
